import { YearMonthParams } from '@/domain/termine/type';
import dayjs from 'dayjs';

export function getRangeForMonth(monthDate: YearMonthParams) {
  const firstDateOfDisplayedMonth = getFirstDateOfDisplayedMonth(monthDate);
  const startOfMonth = firstDateOfDisplayedMonth.startOf('month');
  const endOfMonth = firstDateOfDisplayedMonth.endOf('month');
  const startDate = startOfMonth.startOf('isoWeek');
  const endDate = endOfMonth.endOf('isoWeek');
  return { startDate, endDate };
}

export function getFirstDateOfDisplayedMonth(monthDate: YearMonthParams) {
  return dayjs(`${monthDate.year}-${monthDate.month}`);
}
